import type { ReactNode, PropsWithChildren } from 'react';

import { useNavigate } from 'react-router';

import { useTranslate } from '@i18n';
import { Button, ButtonProps, Screen, Heading4 } from '@ui';

import * as css from './UserSettingsRoot.css';

export type UserSettingsRootProps = {
    start?: ReactNode;
    end: ReactNode;
};

export const UserSettingsRoot = ({ start, end, children }: PropsWithChildren<UserSettingsRootProps>) => {
    const t = useTranslate();
    return (
        <Screen.Root
            title={t('user_settings.title')}
            header={{
                static: {
                    start,
                    end,
                },
            }}
        >
            <Screen.Column span="20/20">
                <div className={css.content}>{children}</div>
            </Screen.Column>
        </Screen.Root>
    );
};

export type SaveButtonProps = Pick<ButtonProps, 'isLoading' | 'isDisabled'> & {
    onClick?: (() => void) | undefined;
};

export const SaveButton = ({ onClick, ...rest }: SaveButtonProps) => {
    const t = useTranslate();
    return (
        <Button variant="primary" onClick={onClick} {...rest}>
            {t('generic_ui.save')}
        </Button>
    );
};

export const CancelButton = () => {
    const navigate = useNavigate();
    const t = useTranslate();
    return (
        <Button variant="secondary" onClick={() => navigate(-1)}>
            {t('generic_ui.cancel')}
        </Button>
    );
};

const commitSha = import.meta.env['VITE_PUBLIC_GIT_COMMIT_SHA'];
export const CommitSha = () => {
    const t = useTranslate();
    if (!commitSha) {
        return null;
    }
    return (
        <div className={css.commitSha}>
            <Heading4>
                {t('user_settings.version')}: {commitSha}
            </Heading4>
        </div>
    );
};
